import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ArrowContainer, Popover } from "react-tiny-popover";
import { Box, Flex } from "rebass";
import useResponsive from "../../hooks/useResponsive";
import { selectTextColor } from "../../utils/selectColorFunction";

const ColorTooltip = ({
  id,
  code,
  productId,
  cursor,
  colorDescription,
  rgb,
  componentName,
  type,
  onClick,
  isOrderMobile,
  isSelected = false,
  enableMobileTooltip = false,
  isCatalogue = false,
  hideLabel = false,
}) => {
  const [visible, setVisible] = useState(false);
  const { catalogueItemDetails } = useSelector((state) => state.yodaCatalogue);
  const { catalogueItemDetailsSwap } = useSelector(
    (state) => state.yodaCatalogue,
  );
  const { catalogue } = useSelector((state) => state.yodaCatalogue);
  const [pantone, setPantone] = useState("");

  const { type: deviceType } = useResponsive();
  let catalogueItem;
  let product;
  let tmpArray = [];

  function enter() {
    setTimeout(() => setVisible(true), 200);
  }

  function leave() {
    setTimeout(() => setVisible(false), 200);
  }

  useEffect(() => {
    const handleScroll = () => {
      setVisible(false);
    };

    const scrollableElement = document.getElementById("scrollContainer");
    if (scrollableElement) {
      scrollableElement.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (scrollableElement) {
        scrollableElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  if (type === "REORDER") {
    catalogueItem = catalogueItemDetails;
  } else {
    catalogueItem = catalogueItemDetailsSwap;
  }

  useEffect(() => {
    switch (componentName) {
      case "orderDetailsProductReorderAndSwap":
        Object.keys(catalogueItem).forEach((e) => {
          tmpArray.push(catalogueItem[e]);
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
        product = tmpArray?.filter((f) => f.productId == productId);

        if (product.length == 1) {
          product = product[0];
          let color = product?.catalog.filter((f) => f.colorCode == code);
          if (color.length > 0) {
            color = color[0];
            setPantone(color.pantone);
          }
        }

        break;
      case "orderDetailsGrillReorderAndSwap":
        Object.keys(catalogueItem).forEach((e) => {
          tmpArray.push(catalogueItem[e]);
        });

        product = tmpArray?.filter((f) => f.productId === id);

        if (product.length === 1) {
          product = product[0];
          let color = product?.catalog.filter((f) => f.colorCode === code);
          if (color.length >= 1) {
            color = color[0];
            setPantone(color.pantone);
          }
        }

        break;
      case "orderDetailsPopupReorderAndSwap":
        Object.keys(catalogueItem).forEach((e) => {
          tmpArray.push(catalogueItem[e]);
        });

        product = tmpArray?.filter((f) => f.productId === id);

        if (product.length === 1) {
          product = product[0];
          let color = product?.catalog.filter((f) => f.colorCode === code);
          if (color.length >= 1) {
            color = color[0];
            setPantone(color.pantone);
          }
        }

        break;
      case "catalogueProductReorderAndSwap":
        product = catalogue.filter((f) => f.productId == productId);

        if (product.length == 1) {
          product = product[0];
          let color = product?.catalog.filter((f) => f.colorCode == code);
          if (color.length >= 1) {
            color = color[0];
            setPantone(color.pantone);
          }
        }

        break;
      case "catalogueGrillReorderSwapAndPopup":
        product = catalogue.filter((f) => f.productId === id);

        if (product.length === 1) {
          product = product[0];
          let color = product?.catalog.filter((f) => f.colorCode === code);
          if (color.length >= 1) {
            color = color[0];
            setPantone(color.pantone);
          }
        }

        break;
      default:
        console.log(`Error to open tooltip`);
    }
  }, [productId, code, id, catalogue, catalogueItem]);

  switch (componentName) {
    case "orderDetailsProductReorderAndSwap":
      return (
        <Flex
          pl={2}
          pr={2}
          pt={2}
          alignItems={"center"}
          sx={{
            color: "#707070",
            cursor: cursor ? cursor : "",
            gap: "3px",
          }}
          {...((!deviceType.mobile || enableMobileTooltip) && {
            onMouseEnter: enter,
            onMouseLeave: leave,
          })}
        >
          <ColorPopup
            isOpen={visible}
            {...{ pantone, rgb, code, colorDescription }}
          >
            <Box sx={{ color: "black" }}>
              <Box
                style={{
                  height: "20px",
                  width: "36px",
                  backgroundColor: rgb,
                  backgroundImage: `url(${pantone})`,
                  backgroundPosition: "center 10%",
                  backgroundSize: "150px",
                  backgroundRepeat: "no-repeat",
                  border: "2px solid #f2f2f2",
                }}
              />
            </Box>
          </ColorPopup>
          <Box style={{ lineHeight: ".8em" }}>{code}</Box>
        </Flex>
      );
    case "orderDetailsGrillReorderAndSwap":
      return isOrderMobile ? (
        <Flex
          height="30px"
          width="75px"
          sx={{
            backgroundColor: rgb,
            backgroundImage: `url(${pantone})`,
            backgroundPosition: "center 10%",
            backgroundSize: "150px",
          }}
          justifyContent="center"
          alignItems="center"
        >
          <label style={{ color: selectTextColor(rgb) }}>{code}</label>
        </Flex>
      ) : (
        <ColorPopup
          isOpen={visible}
          {...{ pantone, rgb, code, colorDescription }}
        >
          <Flex
            onClick={onClick}
            onMouseEnter={enter}
            onMouseLeave={leave}
            sx={{
              marginLeft: "10px",
              width: "80%",
              height: "29px",
              backgroundColor: rgb,
              backgroundImage: `url(${pantone})`,
              backgroundPosition: "center 10%",
              backgroundSize: "150px",
              alignItems: "center",
              justifyContent: "center",
              border: "2px solid #f2f2f2",
            }}
          >
            <label style={{ color: selectTextColor(rgb) }}>{code}</label>
          </Flex>
        </ColorPopup>
      );
    case "orderDetailsPopupReorderAndSwap":
      return isOrderMobile ? (
        <Flex
          height="30px"
          width="75px"
          sx={{
            backgroundColor: rgb,
            backgroundImage: `url(${pantone})`,
            backgroundPosition: "center 10%",
            backgroundSize: "150px",
            border: "2px solid #f2f2f2",
          }}
          justifyContent="center"
          alignItems="center"
        >
          <label style={{ color: selectTextColor(rgb) }}>{code}</label>
        </Flex>
      ) : (
        <ColorPopup
          isOpen={visible}
          {...{ pantone, rgb, code, colorDescription }}
        >
          <Flex
            onClick={onClick}
            onMouseEnter={enter}
            onMouseLeave={leave}
            sx={{
              marginLeft: "10px",
              width: "80%",
              height: "29px",
              backgroundColor: rgb,
              backgroundImage: `url(${pantone})`,
              backgroundPosition: "center 10%",
              backgroundSize: "150px",
              backgroundRepeat: "no-repeat",
              position: "relative",
              outline: isSelected ? ["2px solid black"] : "transparent",
              outlineOffset: "2px",
              border: "2px solid #f2f2f2",
            }}
            justifyContent="center"
            alignItems="center"
          >
            <label style={{ color: selectTextColor(rgb) }}>{code}</label>
          </Flex>
        </ColorPopup>
      );
    case "catalogueProductReorderAndSwap":
      return (
        <Flex
          pl={isCatalogue ? 0 : 2}
          pr={isCatalogue ? 0 : 2}
          pt={2}
          sx={{
            color: "#707070",
            cursor: cursor ? cursor : "",
            gap: "3px",
            width: hideLabel ? "auto" : "50%",
            alignItems: "center",
            justifyContent: isCatalogue ? "left" : "center",
          }}
          {...((!deviceType.mobile || enableMobileTooltip) && {
            onMouseEnter: enter,
            onMouseLeave: leave,
          })}
        >
          <ColorPopup
            isOpen={visible}
            {...{ pantone, rgb, code, colorDescription }}
          >
            <Box style={{ color: "black", position: "relative" }}>
              <Box
                sx={{
                  height: "20px",
                  width: isCatalogue ? "20px" : "32px",
                  backgroundColor: rgb,
                  backgroundImage: `url(${pantone})`,
                  backgroundPosition: "center 10%",
                  backgroundSize: "150px",
                  backgroundRepeat: "no-repeat",
                  border: "2px solid #f2f2f2",
                }}
              />
            </Box>
          </ColorPopup>
          {!hideLabel && (
            <Box
              sx={{
                paddingLeft: "3px",
                lineHeight: ".8em",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {code + (isCatalogue ? "-" + colorDescription : "")}
            </Box>
          )}
        </Flex>
      );
    case "catalogueGrillReorderSwapAndPopup":
      return (
        <ColorPopup
          isOpen={visible}
          {...{ pantone, rgb, code, colorDescription }}
        >
          <Flex
            onClick={onClick}
            justifyContent="center"
            style={{
              position: "relative",
              left: "10px",
              width: "80%",
              height: "29px",
              backgroundColor: rgb,
              backgroundImage: `url(${pantone})`,
              backgroundPosition: "center 10%",
              backgroundSize: "150px",
              backgroundRepeat: "no-repeat",
              alignItems: "center",
              justifyContent: "center",
              outline: isSelected ? ["2px solid black"] : "transparent",
              outlineOffset: "2px",
              border: "2px solid #f2f2f2",
            }}
            {...((!deviceType.mobile || enableMobileTooltip) && {
              onMouseEnter: enter,
              onMouseLeave: leave,
            })}
          >
            <label
              style={{
                color: selectTextColor(rgb),
              }}
            >
              {code}
            </label>
          </Flex>
        </ColorPopup>
      );
    default:
      console.log(`Error to open tooltip`);
      return null;
  }
};

const ColorPopup = ({
  isOpen,
  pantone,
  rgb,
  code,
  colorDescription,
  children,
  ...props
}) => (
  <Popover
    positions={["bottom", "right", "top", "left"]} // preferred positions by priority
    align={"start"}
    padding={0}
    content={({ position, childRect, popoverRect }) => (
      <ArrowContainer
        position={position}
        childRect={childRect}
        popoverRect={popoverRect}
        arrowColor={"black"}
        arrowSize={5}
      >
        <Flex
          flexDirection={"column"}
          sx={{
            width: "auto",
            border: "4px solid black",
            backgroundColor: "white",
            padding: "5px",
            position: "relative",
          }}
        >
          <Box
            sx={{
              width: "auto",
              height: "150px",
              overflow: "hidden",
              margin: "0 auto",
            }}
          >
            <Box
              style={{
                width: "150px",
                height: "150px",
                backgroundColor: rgb,
                backgroundImage: `url(${pantone})`,
                backgroundPosition: "center 10%",
                backgroundSize: "150px",
                backgroundRepeat: "no-repeat",
              }}
            />
          </Box>
          <Box
            style={{
              width: "content-fit",
              height: "20px",
              whiteSpace: "nowrap",
              fontSize: "14px",
            }}
            color="black"
          >
            {code} - <b>{colorDescription.toUpperCase()}</b>
          </Box>
        </Flex>
      </ArrowContainer>
    )}
    {...{ isOpen }}
    {...props}
  >
    {children}
  </Popover>
);

export { ColorTooltip };
